import 'tldraw/tldraw.css'
import {defaultShapeUtils, defaultTools, Editor, Tldraw} from "tldraw";
import {useSync} from "@tldraw/sync";
import React, {useEffect, useMemo, useState} from "react";
import {EditableShapeUtil} from "../customShapeUtils/EditableShapeUtil";
import {DialogToolBarUtil} from "../customShapeUtils/DialogHoverBar";
import {StepLabelShapeUtil} from "../customShapeUtils/StepLabelShapeUtil";
import {TaskLoadingShapeUtil} from "../customShapeUtils/TaskLoadingShapeUtil";
import {LabelShapeUtil} from "../customShapeUtils/LabelShapeUtil";
import {HoverToolBarUtil} from "../customShapeUtils/HoverToolBarUtil";
import {ThumbnailShapeUtil} from "../customShapeUtils/ThumbnailShapeUtil";
import {TagsShapeUtil} from "../customShapeUtils/tagsShapeUtil";
import {LoadingShapeUtil} from "../customShapeUtils/LoadingShapeUtil";
import {DialogShapeUtil} from "../customShapeUtils/DialogShapeUtil";
import {DescribeShapeUtil} from "../customShapeUtils/DescribeShapeUtil";
import {uploadFileAndReturnUrl} from "../util/upload";
import {useLocation} from "react-router-dom";
import {LoginProps} from "../types/authority";
import {socketService} from "../socket/SocketService";
import {TAB_ID} from "@tldraw/editor";
import {useGaEvents} from "../hooks/useGaEvents";
import {debounce} from "lodash";
import {useLazyLoad} from "../hooks/useLazyLoad";
import {useSocketCommands} from "../hooks/useSocketCommands";
import {useCanvasControl} from "../hooks/useCanvasControl";
import {TLAssetId, TLRecord, TLShape} from "@tldraw/tlschema";
import {setPrefabricatedChat} from "../store/styleSlice";
import {getLocalConversionId} from "../util/storage";
import {setCurrentChatOn, setCurrentImageShape, setCurrentStepId} from "../store/drawSlice";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../store";
import {HistoryEntry} from "@tldraw/store";
import {CommandType} from "../types/taskFlow.types";
import {setSelectCanvasImage} from "../store/taskSlice";
import {getBoardInfo} from "../api/boardManage";
import {setUseSuggestion} from "../store/userSlice";
import {caseBoardInfoProps} from "../types/board.types";
import ChatContainer from "../component/chat_container";
import {Dialog, DialogContent, Tooltip} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import droplet from "../assets/droplet.png";
import {Tips} from "../icons";

const base_socket_sync_url = `${process.env.REACT_APP_SOCKET_CANVAS_URL}`;
const base_socket_url = `${process.env.REACT_APP_SOCKET_IO_URL}`;

function LocalMoodBoardComponent(props: {userInfo: LoginProps | null, boardInfo: caseBoardInfoProps | null, setEditorHandle: (editor?: Editor) => void, editor?: Editor, openHistoryTab: number, setOpenHistoryTabHandle: (n: number) => void}) {

    const {userInfo, setEditorHandle, editor, boardInfo, openHistoryTab, setOpenHistoryTabHandle} = props;

    const filteredTools = defaultTools.filter(tool => tool.id !== "eraser")

    const { createHoverBar,selectShape, getLastStepId, createDialogHoverBar, updateParentShape, selectFrameShape, doubleClickArouse, createThumbnailShape, createTagsShape, setLabelToFrame, setLabelToFrameNotDependent, replaceDialogFrame , replaceDescribeFrame} = useCanvasControl(editor)

    const customShapeUtils = [EditableShapeUtil, DialogToolBarUtil, StepLabelShapeUtil, TaskLoadingShapeUtil, LabelShapeUtil, HoverToolBarUtil, ThumbnailShapeUtil, TagsShapeUtil, LoadingShapeUtil, DialogShapeUtil, DescribeShapeUtil]

    const assets = useMemo(() => uploadFileAndReturnUrl(process.env.REACT_APP_CANVAS_UPLOAD || '/psroom/uploads'), []);

    const { sentExitCanvasEvent } = useGaEvents();

    const level2TaskId = useSelector((state: RootState) => state.task.level2TaskId);

    const {loadVisibleImages} = useLazyLoad(editor)

    const dispatch = useDispatch();

    const initPrefabricatedChat = useSelector((state: RootState) => state.style.initPrefabricatedChat);

    const { getImages, getSuggestions } = useSocketCommands()

    const useSuggestion = useSelector((state: RootState) => state.user.useSuggestion)

    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const boardId = queryParams.get('boardId');

    const [openTips, setOpenTips] = useState<boolean>(false)

 /*   useEffect(() => {
        if (userInfo && boardId && editor) {
            socketService.connect(`${base_socket_url}?token=${userInfo.token}&boardId=${boardId}&tabId=${TAB_ID}`, boardId);
        }
        return () => {
            sentExitCanvasEvent({board_id: boardId as string})
            socketService.disconnect();
        };
    }, [userInfo, boardId, editor]);*/

    const store = useSync({
        uri: `${base_socket_sync_url}?roomId=${boardId}&token=${userInfo ? userInfo.token : ''}`,
        assets,
        shapeUtils: useMemo(() => [...customShapeUtils, ...defaultShapeUtils], [])
    })

    // 在 store 连接后，设置只读模式并阻止发送消息
    useEffect(() => {
        if (store.status !== 'synced-remote' || !editor) return;

        // 获取 store 的 collaboration mode 并设置为 readonly
        const storeInstance = editor.store as any;
        const collaborationMode = storeInstance.props?.collaboration?.mode;
        if (collaborationMode) {
            // 强制设置为只读模式
            collaborationMode.set('readonly');
        }

        // 通过修改 TLSyncClient 的 push 方法来阻止发送消息
        // 获取 TLSyncClient 实例（通过 window.tlsync 访问）
        const syncClient = (window as any).tlsync;
        if (syncClient && syncClient.store === editor.store) {
            // 保存原始的 push 方法
            const originalPush = syncClient.push?.bind(syncClient);
            if (originalPush) {
                // 重写 push 方法，在 readonly 模式下不发送消息
                syncClient.push = function(changes: any) {
                    // 检查 collaboration mode，如果是 readonly 则不发送
                    const store = this.store as any;
                    const mode = store.props?.collaboration?.mode?.get();
                    if (mode === 'readonly') {
                        // 只读模式，不发送消息，但仍然可以接收服务器消息
                        return;
                    }
                    // 非只读模式，正常发送
                    return originalPush.call(this, changes);
                };
            }
        }
    }, [editor, store.status])

    useEffect(() => {
        if (!editor) return;

        loadVisibleImages().then();

        // 使用防抖处理的视口变化处理函数
        const handleViewportChange = debounce(async () => {
            const visibleImages = await loadVisibleImages();
            if (visibleImages && visibleImages.length > 0) getImages(visibleImages)
        }, 300);

        // 监听相机变化
        editor.on('change', handleViewportChange);

        return () => {
            editor.off('stop-camera-animation', handleViewportChange);
            // 同时取消任何待处理的防抖函数调用
            handleViewportChange.cancel();
        };
    }, [editor]);

    const selectLastStep = () => {
        if (!editor) return;
        const lastStepId = getLastStepId()
        if (lastStepId) {
            const shapes = editor.getCurrentPageShapes();
            const stepShape =  shapes.find(shape => shape.meta.stepId === lastStepId && shape.meta.isMainContainer);
            if (stepShape && !stepShape.meta.selected) {
                changeIniPrefabricated(initPrefabricatedChat?.onFocusStep, 'onFocusStep', stepShape)
                selectShape(stepShape);
            }
        }
    }

    const changeIniPrefabricated = (suggestions?: {text: string}[], type?: string, shape?: TLShape) => {
        if (!useSuggestion) return
        if (type === 'onBoardInit') {
            if(suggestions) dispatch(setPrefabricatedChat(suggestions))
        }else {
            if(suggestions) dispatch(setPrefabricatedChat([]))
        }
        const conversationId = getLocalConversionId(boardId as string);
        if (type === 'onFocusImage' && shape) {
            const assetId = 'assetId' in shape.props ? shape.props.assetId : ''
            const asset = editor?.getAsset(assetId as TLAssetId);
            dispatch(setCurrentChatOn({type: 'image', img: asset?.props.src || ''}))
            dispatch(setCurrentImageShape(
                {
                    shapeId: shape.id,
                    assetId: assetId as string,
                    url: asset?.props.src || '',
                    meta: shape.meta as unknown as string,
                    uuid: asset?.meta.uuid as string
                }))
            getSuggestions(conversationId, 'onFocusImage', null, shape.meta.taskId as number, asset?.meta.uuid as string)
        }
        if (type === 'onFocusCard' && shape) {
            dispatch(setCurrentChatOn(null))
            getSuggestions(conversationId, 'onFocusCard', null, shape.meta.taskId as number)
        }
        if (type === 'onFocusStep' && shape) {
            dispatch(setCurrentChatOn(null))
            const stepId = shape.meta.stepId as string
            getSuggestions(conversationId, 'onFocusStep', stepId)
        }
    }

    useEffect(() => {
        selectLastStep()
    }, [editor, initPrefabricatedChat, useSuggestion]);

    const handlePointerMove = (e: HistoryEntry<TLRecord>) => {
        if (!editor) return;
        // @ts-ignore
        const pointer = e.changes.updated['pointer:pointer']?.[0];
        const selectedShapeIds = editor.getSelectedShapeIds();
        const croppingShapeId = editor.getCurrentPageState().croppingShapeId

        const shapes = editor.getCurrentPageShapes();

        const chatBindShape =  shapes.find(shape => shape.meta.selected);

        if (croppingShapeId) {
            const cropShape = editor?.getShape(croppingShapeId);
            if (cropShape?.meta.taskId) {
                doubleClickArouse(cropShape)
                editor?.setCroppingShape(null);
            }
        }

        const selectedShapes = selectedShapeIds.map(id => editor.getShape(id));

        if (chatBindShape) {
            const pageBounds = editor.getShapePageBounds(chatBindShape);

            if (!pageBounds) return;

            let centerPagePoint = {
                x: pageBounds.minX + pageBounds.width / 2,
                y: pageBounds.maxY + 20,
            };

            const hoverChatDom = document.getElementById('hover-chat');
            let x = 0;
            let y = 0;
            let offset = 0
            let offsetY = 50
            offset = 234
            offsetY = 0

            if (chatBindShape.meta.hasChildren) { // 如果有下级step则显示在左侧居中
                centerPagePoint = {
                    x: pageBounds.maxX + 30, // 右边缘
                    y: pageBounds.minY + pageBounds.height / 2, // 垂直中心
                };
                offset = 0
                offsetY = 50
            }


            const position = editor.pageToScreen(centerPagePoint)


            x = position.x - offset < 8 ? offset ? 242 : 8 : position.x;
            y = position.y - offsetY < 8 ? 8 + offsetY : position.y;

            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight

            if (x >  screenWidth - 476 + offset) x =  screenWidth - 476 + offset

            if (hoverChatDom) {
                if (y > screenHeight - hoverChatDom?.offsetHeight - 8 + offsetY) y = screenHeight - hoverChatDom?.offsetHeight - 8 + offsetY;

                hoverChatDom.style.top = '0';
                hoverChatDom.style.left = '0';

                hoverChatDom.style.transform = `translate(${x - offset}px, ${y - offsetY}px)`;
            }
        }else {
            const width = window.innerWidth;
            const height = window.innerHeight;

            const centerX = width / 2;
            const centerY = height / 2;


            const hoverChatDom = document.getElementById('hover-chat');

            if (hoverChatDom) {
                hoverChatDom.style.top = '0';
                hoverChatDom.style.left = '0';

                hoverChatDom.style.transform = `translate(${centerX - 234}px, ${centerY - 50}px)`;
            }
        }

        const removed = Object.values(e.changes.removed);

        if (removed.length) {
            updateParentShape(removed)
        }

        if (pointer) {
            const pointerX = pointer.x
            const pointerY = pointer.y

            const shapeUnderPointer = shapes.filter(shape => {
                // 获取形状在页面中的绝对位置和尺寸
                const pageBounds = editor.getShapePageBounds(shape.id);

                if (!pageBounds) return false;

                // 判断鼠标点是否在形状边界内
                return pointerX >= pageBounds.minX &&
                    pointerX <= pageBounds.maxX &&
                    pointerY >= pageBounds.minY &&
                    pointerY <= pageBounds.maxY;
            });
            const cardShape = shapeUnderPointer.find(shape => shape.type === 'frame' && !shape.meta.isMainContainer);
            const stepShape = shapeUnderPointer.find(shape => shape.type === 'frame' && shape.meta.isMainContainer);
            const imageShape = shapeUnderPointer.find(shape=> shape.type === 'image');


            const allHoverElements = document.querySelectorAll(`[data-hover="1"]`);

            const hoverElementsArray = Array.from(allHoverElements);

            hoverElementsArray.forEach((element, index) => {
                const fill = element.getAttribute('data-origin-fill');
                const dataShapeId = element.getAttribute('data-frame-id');
                if (dataShapeId === chatBindShape?.id) return;
                fill && element.setAttribute('fill', fill);
                element.setAttribute('data-hover', '0');
            });

            if (imageShape) {
                console.log('图片shape')
            }else if (cardShape && cardShape.meta.commandType !== CommandType.PARSER_TASK_CARD) {
                const shapeId = cardShape.id;

                const shapeElement = document.querySelector(`[data-shape-id="${shapeId}"]`)?.getElementsByClassName('tl-frame__body');
                if (shapeId === chatBindShape?.id) return;
                if (shapeElement) {
                    const frameShape = shapeElement[0];
                    const fill = frameShape.getAttribute('fill')
                    frameShape.setAttribute('fill', '#EAE1FF');
                    frameShape.setAttribute('data-origin-fill', fill || '');
                    frameShape.setAttribute('data-hover', '1');
                    frameShape.setAttribute('data-frame-id', shapeId);
                }
            }else if (stepShape || (cardShape?.meta.commandType === CommandType.PARSER_TASK_CARD && stepShape)) {
                const shapeId = stepShape.id;
                const shapeElement = document.querySelector(`[data-shape-id="${shapeId}"]`)?.getElementsByClassName('tl-frame__body');
                if (shapeId === chatBindShape?.id) return;
                if (shapeElement) {
                    const frameShape = shapeElement[0];
                    const fill = frameShape.getAttribute('fill')
                    frameShape.setAttribute('fill', '#EAE1FF');
                    frameShape.setAttribute('data-origin-fill', fill || '');
                    frameShape.setAttribute('data-hover', '1');
                    frameShape.setAttribute('data-frame-id', shapeId);
                }
            }

        }
    };

    useEffect(() => {
        if (!editor) return;
        const shapes = editor.getCurrentPageShapes();

        const chatBindShape =  shapes.find(shape => shape.meta.selected);

        if (chatBindShape?.type === 'image'){
            changeIniPrefabricated(initPrefabricatedChat?.onFocusImage, 'onFocusImage', chatBindShape)
        }else if (chatBindShape?.type === 'frame' && !chatBindShape.meta.isMainContainer) {
            // @ts-ignore
            changeIniPrefabricated(initPrefabricatedChat?.[`onFocusCard_${chatBindShape.meta.commandType}`], 'onFocusCard', chatBindShape)
        }else if (chatBindShape?.type === 'frame' && chatBindShape.meta.isMainContainer) {
            changeIniPrefabricated(initPrefabricatedChat?.onFocusStep, 'onFocusStep', chatBindShape)
        }else {
            changeIniPrefabricated(initPrefabricatedChat?.onBoardInit, 'onBoardInit')
        }
    }, [editor, initPrefabricatedChat, useSuggestion]);

    useEffect(() => {
        if (!editor || boardInfo?.type === 'FORKED') return;

        const handleClick = (event: MouseEvent) => {

            const clickDome = event.target;

            // @ts-ignore
            if (!clickDome.hasAttribute('data-testid') || ['CancelIcon', 'DeleteOutlineOutlinedIcon'].includes(clickDome.getAttribute('data-testid'))) return;

            const point = editor.inputs.currentPagePoint;
            const allShapes = editor.getCurrentPageShapes();

            const containingFrame = allShapes.filter(shape => {
                const pageBounds = editor.getShapePageBounds(shape.id);

                if (!pageBounds) return false;

                // 判断鼠标点是否在形状边界内
                return point.x >= pageBounds.minX &&
                    point.x <= pageBounds.maxX &&
                    point.y >= pageBounds.minY &&
                    point.y <= pageBounds.maxY;
            });

            if (containingFrame) {
                console.log('包含点击点的 frame:', containingFrame);
            } else {
                console.log('未找到包含点击点的 frame');
            }

            dispatch(setCurrentImageShape(null))

            const imageShape = containingFrame.find(shape=> shape.type === 'image');
            const cardShape = containingFrame.find(shape => shape.type === 'frame' && !shape.meta.isMainContainer);
            const stepShape = containingFrame.find(shape => shape.type === 'frame' && shape.meta.isMainContainer);
            const conversationId = getLocalConversionId(boardId as string);

            if (stepShape) {
                editor.select(stepShape.id)
                dispatch(setCurrentStepId(stepShape.meta.stepId as string))
            }

            if (imageShape) {
                if (!imageShape.meta.taskId) return;
                changeIniPrefabricated(initPrefabricatedChat?.onFocusImage, 'onFocusImage', imageShape)
                editor.select(imageShape.id)
                selectShape(imageShape);
                return;
            }

            if (cardShape) {
                if (cardShape.meta.commandType === CommandType.PARSER_TASK_CARD && stepShape) {
                    /*                    changeIniPrefabricated(initPrefabricatedChat?.onFocusStep, 'onFocusStep', stepShape)
                                        editor.select(stepShape.id)
                                        selectShape(stepShape);*/
                    editor.select(cardShape.id)
                    return;
                }
                // @ts-ignore
                changeIniPrefabricated(initPrefabricatedChat?.[`onFocusCard_${cardShape.meta.commandType}`], 'onFocusCard', cardShape)
                editor.select(cardShape.id)
                selectShape(cardShape);
                return;
            }

            if (stepShape) {
                changeIniPrefabricated(initPrefabricatedChat?.onFocusStep, 'onFocusStep', stepShape)
                editor.select(stepShape.id)
                selectShape(stepShape);
                return;
            }

            // 默认回到最后的step
            selectLastStep()
        };

        document.addEventListener('click', handleClick, true);

        return () => {
            document.removeEventListener('click', handleClick, true);
        };
    }, [editor, initPrefabricatedChat, boardId, useSuggestion]);

    useEffect(() => {
        if (!editor || boardInfo?.type === 'FORKED') return;

        editor.on('change', handlePointerMove);

        return () => {
            editor.off('change', handlePointerMove);
        };
    }, [editor, boardInfo]);

    useEffect(() => {
        if (!editor) return;
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                const selectedShapeIds = editor.getSelectedShapeIds();
                const selectedShapes = selectedShapeIds.map(id => editor.getShape(id));
                if (selectedShapes && selectedShapes.length === 1 && selectedShapes[0]!.type === 'image') {
                    const [shape] = selectedShapes;
                    if (!shape) return;
                    const assetId = 'assetId' in shape.props ? shape.props.assetId : ''
                    const asset = editor.getAsset(assetId as TLAssetId);
                    const imageData = JSON.parse(asset?.meta.imageData as string)
                    dispatch(setSelectCanvasImage([imageData.url]))
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [editor]);

    // user config is initialized globally in App

    return <>
        <Dialog
            open={openTips}
            onClose={()=>{setOpenTips(false)}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: "20px"
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                <div style={{width: '476px', padding: '20px 20px 10px 20px', fontSize: '14px'}}>
                    <div style={{color: 'var(--c-text-primary)', fontSize: '18px', fontWeight: 'bold'}}>
                        【重要提醒】探索绘板现已封存，仅开放只读模式。请尽快备份您的重要资产。
                    </div>
                    <p>亲爱的用户：</p>
                    <div>为给大家长期提供更好的服务，「探索绘板」现已封存，仅开放<span style={{color: 'var(--c-text-primary)', fontWeight: 'bold'}}>只读模式</span>。</div>
                    <div>在只读模式下：</div>
                    <ul style={{color: 'var(--c-text-primary)', fontSize: '14px'}}>
                        <li>您仍可正常查看历史「探索绘板」里的已有内容。</li>
                        <li>您可手动下载历史「探索绘板」内的图片等资产。</li>
                        <li>您无法在「探索绘板」内进行编辑、新建或其他操作。</li>
                    </ul>

                    <p> 在封存阶段，我们会继续保留已存储的相关数据，确保您可随时查看。</p>

                    <p>
                        但考虑到<span style={{color: 'var(--c-text-primary)', fontWeight: 'bold'}}>该模式将在未来逐步下线</span>，「探索绘板」相关入口将不再显示。为避免后期数据丢失，我们建议您请尽快备份您的重要资产。
                        感谢您一直以来的陪伴和支持。
                    </p>

                    <div style={{position: 'relative', height: '40px'}}> {/* 父容器需要设定高度 */}
                        <div onClick={() => {
                            setOpenTips(false)
                        }} style={{
                            position: 'absolute',
                            right: 0,
                            color: '#FFFFFF',
                            borderRadius: '20px',
                            textAlign: 'center',
                            lineHeight: '32px',
                            height: '32px',
                            width: '92px',
                            backgroundColor: 'var(--c-brand-light)',
                            cursor: 'pointer'
                        }}>确认
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
        <div className='moodboardTips' onClick={() => {
            setOpenTips(true)
        }}>
            【重要提醒】探索绘板已进入只读模式，并将于近期下线。为避免数据丢失，请立即备份您的资产。
        </div>
        <Tldraw
            store={store}
            shapeUtils={customShapeUtils}
            tools={filteredTools}
            onMount={(editor) => {
                setEditorHandle(editor)
                // 创建导入按钮和文件输入
                const importButton = document.createElement('button');
                importButton.textContent = '导入JSON';
                importButton.style.cssText = `
            position: fixed;
            top: 10px;
            right: 180px;
            padding: 8px 16px;
            background-color: var(--c-accent);
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            z-index: 1000;
            display: none;
          `;

                const fileInput = document.createElement('input');
                fileInput.type = 'file';
                fileInput.accept = 'application/json';
                fileInput.style.display = 'none';

                fileInput.onchange = async (e) => {
                    const file = (e.target as HTMLInputElement).files?.[0];
                    if (file) {
                        const text = await file.text();
                        try {
                            const json = JSON.parse(text);
                            editor.store.loadSnapshot(json);
                        } catch (err) {
                            alert('无效的 JSON 文件');
                        }
                    }
                };

                importButton.onclick = () => fileInput.click();

                document.body.appendChild(importButton);
                document.body.appendChild(fileInput);
            }}
        />
        {
            <div className='chatContain'
                 style={{width: openHistoryTab ? '20%' : '0', display: level2TaskId ? 'none' : 'block'}}>
                <ChatContainer boardInfo={boardInfo} controlHistory={setOpenHistoryTabHandle} editor={editor}
                               openHistoryTab={openHistoryTab}/>
            </div>
        }
    </>
}

export default LocalMoodBoardComponent